import Point from '../../Utility/Point';
import Renderable from '../Renderable';
import ObservablePoint from '../../Utility/ObservablePoint';
import Text from '../../Prototype/Text';
import * as PIXI from 'pixi.js';
import TextBoundaryComponent from '../TextBoundary';

export default class TextComponent extends Renderable<PIXI.Text, Text> {
    get text(): string {
        return this.container.text;
    }

    set text(value: string) {
        this.container.text = value;
        if (this.gameObject.hasComponent(TextBoundaryComponent)) {
            const boundary: TextBoundaryComponent = this.gameObject.getComponent(
                TextBoundaryComponent
            );
            boundary.bounds = boundary.bounds;
        }
    }

    get anchor(): Point | ObservablePoint {
        return this.container.anchor as Point | ObservablePoint;
    }

    set anchor(value: Point | ObservablePoint) {
        this.container.anchor.set(value.x, value.y);
    }

    get style() {
        return this.container.style;
    }

    set style(value) {
        this.container.style = value;
    }
}
